export default __webpack_public_path__ + "static/media/log-out.34a85798.svg";